import React from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SupplierOrderDto } from '../api/supplierOrdersApi';

interface SupplierOrderDraftReviewBannerProps {
  supplierOrder: Pick<SupplierOrderDto, 'draftReviewStatus' | 'draftSourceOrderId' | 'draftRejectionReason'>;
}

/**
 * A rejected confirmation draft ZD says why it was rejected (decision
 * 2026-10-04 pkt 4). A draft that still waits — and every other ZD in stage
 * „Szkic” — is handled by the stage panel of the ZD card
 * (SupplierOrderDraftStagePanel: choose the supplier, lines and prices, send,
 * reject), so this banner shows the rejected state only.
 */
const SupplierOrderDraftReviewBanner: React.FC<SupplierOrderDraftReviewBannerProps> = ({ supplierOrder }) => {
  const { t } = useTranslation(['orders']);
  if (supplierOrder.draftReviewStatus !== 'REJECTED') return null;

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 12 }}
      data-testid="supplier-order-draft-rejected"
      message={t('orders:supplierOrders.drafts.rejectedBanner')}
      description={(
        <>
          {supplierOrder.draftRejectionReason && (
            <div>{t('orders:supplierOrders.drafts.rejectedReason', { reason: supplierOrder.draftRejectionReason })}</div>
          )}
          {supplierOrder.draftSourceOrderId ? (
            <Link to={`/app/orders/${supplierOrder.draftSourceOrderId}`}>
              {t('orders:supplierOrders.drafts.openSourceOrder')}
            </Link>
          ) : null}
        </>
      )}
    />
  );
};

export default SupplierOrderDraftReviewBanner;
